<template>
    <div class="menu container" id="million-bit-menu">
      
      <b-button v-bind:variant="variantNavButton" v-on:click="$router.push('/')" class="btn-icon btn-block btn-lg">
        Homepage
      </b-button>

      <b-button v-bind:variant="variantNavButton" class="btn-icon btn-block btn-lg" v-on:click="$router.push('/about')">
        About
      </b-button>

      <b-button v-bind:variant="variantNavButton" class="btn-icon btn-block btn-lg" v-on:click="$router.push('/leaderboard')">
        Leaderboard
      </b-button>
            
      <b-button v-bind:variant="variantNavButton" class="btn-icon btn-block btn-lg" v-on:click="$router.push('/plots')">
        My Plots
      </b-button>

      <b-button v-bind:variant="variantNavButton" v-on:click="$router.push('/list')" class="btn-icon btn-block btn-lg">
        Pixel List
      </b-button>

      <b-button v-bind:variant="variantNavButton" class="btn-icon btn-block btn-lg" v-on:click="$router.push('/break')">
        Break 

        <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" class="bi bi-joystick" viewBox="0 0 16 16">
          <path d="M10 2a2 2 0 0 1-1.5 1.937v5.087c.863.083 1.5.377 1.5.726 0 .414-.895.75-2 .75s-2-.336-2-.75c0-.35.637-.643 1.5-.726V3.937A2 2 0 1 1 10 2"/>
          <path d="M0 9.665v1.717a1 1 0 0 0 .553.894l6.553 3.277a2 2 0 0 0 1.788 0l6.553-3.277a1 1 0 0 0 .553-.894V9.665c0-.1-.06-.19-.152-.23L9.5 6.715v.993l5.227 2.178a.125.125 0 0 1 .001.23l-5.94 2.546a2 2 0 0 1-1.576 0l-5.94-2.546a.125.125 0 0 1 .001-.23L6.5 7.708l-.013-.988L.152 9.435a.25.25 0 0 0-.152.23"/>
        </svg>
      </b-button>

      <b-button v-bind:variant="variantNavButton" class="btn-icon btn-block btn-lg" v-on:click="$router.push('/drop')">
        Drop 

        <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" class="bi bi-joystick" viewBox="0 0 16 16">
          <path d="M10 2a2 2 0 0 1-1.5 1.937v5.087c.863.083 1.5.377 1.5.726 0 .414-.895.75-2 .75s-2-.336-2-.75c0-.35.637-.643 1.5-.726V3.937A2 2 0 1 1 10 2"/>
          <path d="M0 9.665v1.717a1 1 0 0 0 .553.894l6.553 3.277a2 2 0 0 0 1.788 0l6.553-3.277a1 1 0 0 0 .553-.894V9.665c0-.1-.06-.19-.152-.23L9.5 6.715v.993l5.227 2.178a.125.125 0 0 1 .001.23l-5.94 2.546a2 2 0 0 1-1.576 0l-5.94-2.546a.125.125 0 0 1 .001-.23L6.5 7.708l-.013-.988L.152 9.435a.25.25 0 0 0-.152.23"/>
        </svg>
      </b-button>

      <b-button v-bind:variant="variantNavButton" class="btn-icon btn-block btn-lg" v-on:click="$router.push('/spaces')">
        Based <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" class="bi bi-twitter-x" viewBox="0 0 16 16">
          <path d="M12.6.75h2.454l-5.36 6.142L16 15.25h-4.937l-3.867-5.07-4.425 5.07H.316l5.733-6.57L0 .75h5.063l3.495 4.633L12.601.75Zm-.86 13.028h1.36L4.323 2.145H2.865z"/>
        </svg> Spaces
      </b-button>

      <b-button v-bind:variant="variantNavButton" v-on:click="$router.push('/subscribe')" class="btn-icon btn-block btn-lg">
        Subscribe
      </b-button>
    </div>
  </template>
  
  <script>
  export default {
    name: 'nav-menu',
    data () {
      return {
        variantNavButton: 'warning',
      }
    },
    inject: ['updateAppRoute', 'appData', 'postToLambda'],
    created: function () {
      this.updateAppRoute('menu');
    }
  }
  </script>
  
  <!-- Add "scoped" attribute to limit CSS to this component only -->
  <style scoped>
    #million-bit-menu {
      background: #fff !important;
      padding: 20px;
      text-align: left;
    }
    #million-bit-menu ul {
      list-style: none;
    }
    button.btn.btn-icon.btn-block.btn-lg.btn-warning {
      border-color: #000;
      border-bottom: 3px solid #000;
    }

    #million-bit-menu button:hover {
      box-shadow: #000 0px 0px 10px;
      border-bottom: 3px solid #000;
    }

    #million-bit-menu button:nth-child(1) {
      background: #ffffb2;
    }
    #million-bit-menu :nth-child(2) {
      background: #ffffa2;
    }
    #million-bit-menu :nth-child(3) {
      background: #ffff8a;
    }
    #million-bit-menu :nth-child(4) {
      background: #ffe265;
    }
    #million-bit-menu :nth-child(5) {
      background: #ffc553;
    }
    #million-bit-menu :nth-child(6) {
      background: #ffa059;
    }
    #million-bit-menu :nth-child(7) {
      background: #ff6871;
    }
    #million-bit-menu :nth-child(8) {
      background: #ff538f;
    }
    #million-bit-menu :nth-child(9) {
      background: #ff41af;
    }
  </style>
  


// WEBPACK FOOTER //
// src/components/Menu.vue?29f001ac